import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useTranslation } from '@frontend/i18n';
import { Photos } from '@frontend/photos';
import { CheckboxField, Text, useControlledField, useTooltip } from '@frontend/design-system';
import { styles } from './styles';

type StartColumnProps = {
  data: GetPatientsBalanceResponse_PatientBalance;
  isSelected: boolean;
};

export const StartColumn = ({ data, isSelected }: StartColumnProps) => {
  const { t } = useTranslation('payments');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip();

  const isCheckboxDisabled = data.locationIds?.length > 1 || !data.phoneNumber;

  const selectProps = useControlledField({
    onChange: () => {}, // handled by row click
    type: 'checkbox',
    value: isSelected,
  });

  return (
    <div css={styles.startColumn.container} {...(isCheckboxDisabled ? triggerProps : {})}>
      <CheckboxField
        {...selectProps}
        name='deselect'
        label=''
        disabled={data.locationIds?.length > 1 || !data.phoneNumber}
      />
      <Photos.ContactProfilePhoto
        name={data.firstName + ' ' + data.lastName}
        personId={data.patientId}
        locationId={data.locationIds?.[0]}
        size='small'
      />
      <Tooltip {...tooltipProps}>
        <Text color='white' size='small'>
          {t("Request can't be created because no phone number is on file")}
        </Text>
      </Tooltip>
    </div>
  );
};
